import { Box } from '@mui/material'
import SwipeableDrawerRightDialog from '../../../../components/Dialogs/SwipeableDrawerRightDialog'
import { useMemo, useState } from 'react'
import { TConfirmDialogButton } from '../../../../components/Dialogs/DialogActions/DialogActionButton'
import TypePaymentChoose from '../TypePaymentChoose'
import TypeDeliveryChoose from '../TypeDeliveryChoose'
import {
  TProductDelivery,
  TProductSocialMedia,
  TProductTypeChoose,
  TProductTypePayment,
} from '../../../../core/types/Product'
import ErrorSnackbar from '../../../../components/Snackbar/ErrorSnackbar'
import SocialMediaChoose from '../SocialMediaChoose'

interface ITypePaymentChoose {
  open: boolean
  onClose: () => void
  onChange: (value: TProductTypeChoose) => void
  setOpen: (value: boolean) => void
}

const ProductTypeChoose = ({
  open,
  onClose,
  setOpen,
  onChange,
}: ITypePaymentChoose) => {
  const [activeStep, setActiveStep] = useState(0)
  const [productDelivery, setProductDelivery] = useState<TProductDelivery>(
    TProductDelivery.Course
  )
  const [productSocialMedia, setProductSocialMedia] =
    useState<TProductSocialMedia>(TProductSocialMedia.Telegram)
  const [error, setError] = useState('')

  const step = useMemo(
    () => ({
      isActiveDelivery: activeStep === 0,
      isActiveSocialMedia:
        activeStep === 1 && productDelivery === TProductDelivery.Community,
      isActivePayment:
        (activeStep === 1 && productDelivery !== TProductDelivery.Community) ||
        (activeStep === 2 && productDelivery === TProductDelivery.Community),
    }),
    [activeStep, productDelivery]
  )

  const handleChangePreview = () => {
    setActiveStep((as) => as - 1)
  }

  const handleChangeNext = () => {
    setActiveStep((as) => as + 1)
  }

  const handleChangeSave = () => {
    setError('Selecione uma opção')
  }

  const handleChangeDelivery = (value: TProductDelivery) => {
    if (value === TProductDelivery.Ticket) {
      onChange({
        delivery: value,
        typePayment: TProductTypePayment.OneTimePayment,
        socialMedia: TProductSocialMedia.Telegram,
      })
      setActiveStep(0)
      return
    }
    setProductDelivery(value)
    handleChangeNext()
  }

  const handleChangeSocialMedia = (value: TProductSocialMedia) => {
    setProductSocialMedia(value)
    handleChangeNext()
  }

  const handleChangeTypePayment = (value: TProductTypePayment) => {
    onChange({
      delivery: productDelivery,
      typePayment: value,
      socialMedia: productSocialMedia,
    })
    setActiveStep(0)
  }

  const handleChangeClose = () => {
    setActiveStep(0)
    onClose()
    setProductDelivery(TProductDelivery.Course)
    setProductSocialMedia(TProductSocialMedia.Telegram)
  }

  const getTitle = () => {
    const titles =
      productDelivery === TProductDelivery.Community
        ? ['o tipo da entrega', 'a rede social', 'o tipo de pagamento']
        : ['o tipo de entrega', 'o tipo de pagamento']
    return `Selecione ${titles[activeStep]} do produto`
  }

  const getButtons = (): TConfirmDialogButton[] => {
    const buttons: TConfirmDialogButton[][] = [
      [
        {
          title: 'Cancelar',
          type: 'negative',
          event: 'button',
          onClick: handleChangeClose,
        },
      ],
      [
        {
          title: 'Voltar',
          type: 'negative',
          event: 'button',
          onClick: handleChangePreview,
        },
      ],
      [
        {
          title: 'Voltar',
          type: 'negative',
          event: 'button',
          onClick: handleChangePreview,
        },
        {
          title: 'Próximo',
          type: 'positive',
          event: 'button',
          onClick: handleChangeNext,
        },
      ],
      [
        {
          title: 'Voltar',
          type: 'negative',
          event: 'button',
          onClick: handleChangePreview,
        },
      ],
    ]
    return buttons[activeStep]
  }

  return (
    <>
      <SwipeableDrawerRightDialog
        open={open}
        setOpen={setOpen}
        onClose={handleChangeClose}
        title={getTitle()}
        subtitle="Selecione abaixo uma opção"
        buttons={getButtons()}
        maxWidth={step.isActiveDelivery ? 'lg' : 'sm'}
      >
        <Box>
          <Box sx={{ display: step.isActiveDelivery ? undefined : 'none' }}>
            <TypeDeliveryChoose onChange={handleChangeDelivery} />
          </Box>
          <Box sx={{ display: step.isActiveSocialMedia ? undefined : 'none' }}>
            <SocialMediaChoose onChange={handleChangeSocialMedia} />
          </Box>
          <Box sx={{ display: step.isActivePayment ? undefined : 'none' }}>
            <TypePaymentChoose
              onOneTimePayment={() =>
                handleChangeTypePayment(TProductTypePayment.OneTimePayment)
              }
              onRecurringSubscription={() =>
                handleChangeTypePayment(
                  TProductTypePayment.RecurringSubscription
                )
              }
            />
          </Box>
        </Box>
      </SwipeableDrawerRightDialog>

      <ErrorSnackbar open={error !== ''} onClose={() => setError('')}>
        {error}
      </ErrorSnackbar>
    </>
  )
}

export default ProductTypeChoose
